import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable()
export class GenericCountService extends ApiService {
  private http = inject(HttpClient);


  getCount(countUrl) {
    return this.http.get<{ count: number }>(countUrl);
  }
}
